export default {
  data() {
    return {
      columnIndex: 'Column Index (Zero-indexed)',
      parameterNameInFile: 'Parameter Name In File',
      numRuleNoZero: [
        (v) => {
          if (v) {
            if (v == '0') {
              return 'Value cannot be zero'
            } else {
              return /^\d+$/.test(v) || 'Must be positive integer.'
            }
          } else {
            return 'Is required, cannot be null'
          }
        },
      ],
      nullRule: [
        (v) => !!v || 'Is required, cannot be null',
      ],
      nameRule: [
        (v) => {
          if (v) {
            let target = this.ImporterConfigs.find(x => x.Name == v && v != this.Title)
            if (target) {
              return 'This name already exists, please change one.'
            } else {
              return false
            }
          } else {
            return 'Is required, cannot be null'
          }
        },
      ],
    }
  },
  computed: {
    generalData() {
      if (this.importerId) {
        return {
          Name: this.Name,
          ExecuteInterval: this.ExecuteInterval,
          Description: this.Description,
        }
      } else {
        return {}
      }
    },
    title() {
      if (this.importerId) {
        let target = this.ImporterConfigs.find(x => x.Id == this.importerId)
        return target.Name
      } else {
        return this.ImporterType
      }
    },
    showAlertRepeatNG() {
      let IDs = this.NGConfig.map(x => x.TimeSeries.Id)
      IDs = IDs.filter(x => x != undefined && x != '')
      IDs = IDs.sort()
      if (IDs.length > 1) {
        return this.isRepeat(IDs)
      } else {
        return false
      }
    },
    ParameterRepeatNG() {
      let Names = this.NGConfig.map(x => x.ParameterName)
      Names = Names.filter(x => x != undefined && x != '')
      Names = Names.sort()
      if (Names.length > 1) {
        return this.isRepeat(Names)
      } else {
        return false
      }
    },
    IndexRepeatNG() {
      let Indexs = this.NGConfig.map(x => x.Index)
      Indexs = Indexs.filter(x => x != undefined && x != '')
      Indexs = Indexs.sort()
      if (Indexs.length > 1) {
        return this.isRepeat(Indexs)
      } else {
        return false
      }
    },
    canSave() {
      return this.generalCheck && this.sharedCheck && this.mappingCheck
    },
    generalCheck() {
      return this.Name && this.ImporterType && this.ExecuteInterval && !this.ImporterConfigs.find(x => x.Name == this.Name && x.Name != this.title)
    },
    timeSeriesAndColumnIndexCheck() {
      return this.NGConfig.every(x => x.TimeSeries.Id && x.Index && x.Index >= 3) && !this.showAlertRepeatNG && !this.IndexRepeatNG
    },
    timeSeriesAndParameterNameInFileCheck() {
      return this.NGConfig.every(x => x.TimeSeries.Id && x.ParameterName)&& !this.showAlertRepeatNG && !this.ParameterRepeatNG
    },
  },
  methods: {
    NgAlertMsg(type) {
      if (type == 'Goes') {
        return `Aquarius NG: ${this.showAlertTab('tab-1') ? this.$t('OtherTabNeedToFill.MsgNG') : ''} ${this.showAlertRepeatNG ? this.$t('RepetitiveTimeSeries.MsgNG') : ''} ${this.ParameterRepeatNG ? this.$t('RepetitiveTimeSeriesLinkData.MsgNG', {msg:'Parameter Name In File'}) : ''}`
      } else {
        return `Aquarius NG: ${this.showAlertTab('tab-1') ? this.$t('OtherTabNeedToFill.MsgNG') : ''} ${this.showAlertRepeatNG ? this.$t('RepetitiveTimeSeries.MsgNG') : ''} ${this.IndexRepeatNG ? this.$t('RepetitiveTimeSeriesLinkData.MsgNG', {msg:'Column index'}) : ''}`
      }
    },
    close() {
      this.$emit('close', false)
      this.clearAll()
    },
    addLength(Config, type) {
      if (type == 'Goes') {
        Config.push({
          TimeSeries: {},
          ParameterName: '',
        })
      } else {
        Config.push({
          TimeSeries: {},
          Index: null,
        })
      }
    },
    subtractLength(i, Config) {
      if (Config.length != 1) {
        Config.splice(i, 1)
      }
    },
    showAlertTab(model, type) {
      if (type == 'Goes') {
        if (model == 'tab-1') {
          return !(this.NGConfig.every(x => x.TimeSeries.Id && x.ParameterName))
        }
      } 
      else if (type == 'Optimum') {
        if (model == 'tab-1') {
          return !(this.NGConfig.HotFolderName)
        } 
      } 
      else {
        if (model == 'tab-1') {
          return !(this.NGConfig.every(x => x.TimeSeries.Id && x.Index))
        }
      }
    },
    isRepeat(arr) {
      let lookup = {}
      for (let i in arr) {
        if (lookup[arr[i]]) {
          return true
        }
        lookup[arr[i]] = true
      }
      return false
    },
    repeatRule(arr, v) {
      let times = 0
      arr.forEach(x => {
        if (x == v) {
          ++times
        }
      })
      if (times - 1) {
        return true
      } else {
        return false
      }
    },
    parameterNameNullRepeatRule(v, Config) {
      if (v == null || ((typeof v === 'string' || v instanceof String) && v.trim() == '')) {
        return 'Value cannot be empty'
      }
      if (Config[0] && Config[0].ParameterName) {
        let Parameters = Config.map(x => x.ParameterName)
        Parameters = Parameters.filter(x => x != undefined && x != '')
        Parameters = Parameters.sort()
        if (Parameters.length > 1) {
          if (this.repeatRule(Parameters, v)) {
            return 'Value of Parameter Name In File is already mapped to a time series. A Value of Parameter Name In File can only be linked to a single time series.'
          }
        }
      }
      return false
    },
    columnIndexNullRepeatRule(v, Config) {
      if (v == null) {
        return 'Value cannot be null'
      }
      if (!(/^\d+$/.test(v))) {
        return 'Value must be positive integer.'
      }
      if (Config && Config[0] && Config[0].Index) {
        let Indexs = Config.map(x => x.Index)
        Indexs = Indexs.filter(x => x != undefined && x != '')
        Indexs = Indexs.sort()
        if (Indexs.length > 1) {
          if (this.repeatRule(Indexs, v)) {
            return 'Column is already mapped to a time series. A column can only be linked to a single time series.'
          }
        }
      }
      return false
    },
    intMinValueRule(v, minValue, message) {
      if (v < minValue) {
        return message
      }
      return false
    },
    saveSuccess() {
      this.$emit('saveSuccess', {
        snackMessage: this.$t('SaveUpdateDeleteMsg.SaveMsg', { msg: this.Name }),
        snackColor: 'success',
        snackbar: true,
      })
    },
  },
}